import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  flexPoint5: {
    flex: 0.5,
  },
  bloodSugarCardModule: {
    marginHorizontal: 8,
    flexDirection: 'row',
    height: 285,
  },
});
